// ab模块
import {

  WgtNewSlider,
  WgtHotZone,
  WgtHoriZontal,
  WgtblokScroll,
  WgtFilm,

  WgtStickyLift,
  WgtTabsCut,
  WgtOldGoods,
  WgtOldEvaluate,
  WgtWallPaper,

  WgtAroundStoreOne,
  WgtFunctionBlock,
  WgtProductShelves,
  WgtLift,

  WgtContentPart,
  WgtCustomWgt,
  WgtImageText,
  WgtArticle,
  WgtMemberInfo,
  WgtSuspension,
  WgtUserContainer,
  WgtOfficialAccount,
  WgtNewMemberInfo,
  wgtDevices,
  WgtMemberTask
} from "../wgts/index";

export const initiWidgets = [];

export const widgets = {
  WgtNewSlider,

  WgtHotZone,
  WgtHoriZontal,
  WgtblokScroll,
  WgtFilm,

  WgtStickyLift,
  WgtTabsCut,
  WgtOldGoods,
  WgtOldEvaluate,
  WgtWallPaper,

  WgtAroundStoreOne,
  WgtFunctionBlock,
  WgtProductShelves,
  WgtLift,

  WgtContentPart,
  WgtCustomWgt,
  WgtImageText,
  WgtArticle,
  WgtMemberInfo,
  WgtSuspension,
  WgtUserContainer,
  WgtOfficialAccount,
  WgtNewMemberInfo,
  wgtDevices,
  WgtMemberTask
};

export default {
  widgets,
  initiWidgets,
};
